import { api, unwrap } from './client';

export const workforceApi = {
  // Real-time status and Check-in/out
  getMyPresence: () => api.get('/workforce/presence/me').then(unwrap),
  getTeamPresence: () => api.get('/workforce/presence/team').then(unwrap),
  startWork: () => api.post('/workforce/start-work').then(unwrap),
  endWork: () => api.post('/workforce/end-work').then(unwrap),
  updateStatus: (status) => api.post('/workforce/status', null, { params: { status } }).then(unwrap),

  // WFH Requests
  submitWfhRequest: (data) => api.post('/wfh/request', data).then(unwrap),
  getMyWfhRequests: () => api.get('/wfh/my-requests').then(unwrap),
  getMyWfhBalance: () => api.get('/wfh/balance').then(unwrap),
  getPendingWfhRequests: () => api.get('/wfh/pending').then(unwrap),
  approveRejectWfhRequest: (id, status, remarks) => api.put(`/wfh/${id}/approve`, null, { params: { status, remarks } }).then(unwrap),
};
